import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Input } from 'reactstrap';

import './CreateParking.scss';

import commonConstant from '../../common/_commonConstant';
import { randomNumber } from '../../common/_commonFunction';
import { fetchCreateParking, fetchSearchVehicleLicensePlate } from '../../actions';
import { Loading } from '../../components';
import {
  buildingID,
  buildingRefNumber,
  buildingName,
  dateDDMMYYFormat,
  dateYYYYMMDD,
  Dropdown,
  getTimeHHMM,
  getTimeHHMMSS,
  validateVehiclePlate,
  validateToShowDash,
  Toast,
  DropdownSearch,
  IconVehicle,
  vehicleTypeIconName,
  vehicleType,
  Modal,
} from '../../helpers';

class CreateParking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'parkingTimeIn': new Date(),
      'vehicleType': null,
      'vehicleID': null,
      'vehicleBrand': '',
      'vehicleModel': '',
      'vehicleModelYear': '',
      'vehicleColor': '',
      'vehicleLicensePlate': '',
      'vehicleProvince': '',
      'loading': false,
      'canEdit': false,
      'checkAutoFill': false,
      'vehicleData': {},
      'parkingGateLocation': '',
      'parkingGatePosition': '',
      'modalNotAllowParkingZone': false,
    };
    this.vehicleType = createRef();
    this.search = createRef();
    this.toast = createRef();
    this.vehicleProvince = createRef();
    this.vehicleBrand = createRef();
    this.parkingGateLocation = createRef();
    this.parkingGatePosition = createRef();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { createParking } = this.props;
    const { checkAutoFill, vehicleLicensePlate, vehicleProvince, vehicleType } = this.state;

    if (nextProps.createParking && nextProps.createParking !== createParking) {
      if (nextProps.createParking.status === 200) {
        return this.setState({ 'loading': false });
      } else if (nextProps.createParking.status === 400 && nextProps.createParking.errorMessage === commonConstant.trowErrorCreateParkingAlreadyExist) {
        this.toast.current.handleShowToast();
        this.handleSearchVehiclePlate(vehicleLicensePlate);
        return this.setState({ 'checkAutoFill': true });
      } else if (nextProps.createParking.status === 400 && nextProps.createParking.errorMessage === commonConstant.throwErrorParkingZoneNotAllow) {
        this.setState({ 'modalNotAllowParkingZone': true });
      }
      return this.setState({ 'loading': false });
    } else if (nextProps.searchVehicleLicensePlate && checkAutoFill) {
      const findIndex = nextProps.searchVehicleLicensePlate.findIndex(ele => (
        ele.vehicleLicensePlate === vehicleLicensePlate
        && ele.vehicleProvince === vehicleProvince
        && ele.vehicleType === vehicleType.value
      ));
      this.setState({ 'checkAutoFill': false });

      if (findIndex !== -1) {
        this.handleSelectItem(nextProps.searchVehicleLicensePlate[findIndex]);
        return this.toast.current.handleShowToast();
      }
    }
  }

  handleDropdownItems = (key) => {
    try {
      const { vehicleType, vehicleProvince, vehicleBrand, parkingGateLocation, parkingGatePosition } = this.state;
      const { iotDevices } = this.props;

      switch (key) {
        case 'type':
          return commonConstant.vehicleType.map((ele, index) => (
            <div
              id={`vehicle-type-${index}`}
              className={`item${vehicleType && vehicleType.value === ele.value ? ' active' : ''}`}
              key={randomNumber()}
              onClick={() => this.handleEvent(ele, 'vehicleType')}
            >
              <span>{ele.label}</span>
            </div>
          ));
        case 'province':
          return commonConstant.province.map((ele, index) => (
            <div
              id={`vehicle-province-${index}`}
              className={`item${vehicleProvince === ele.value ? ' active' : ''}`}
              key={randomNumber()}
              onClick={() => this.handleEvent(ele.value, 'vehicleProvince')}
            >
              <span>{ele.label}</span>
            </div>
          ));
        case 'brand':
          return commonConstant.vehicleBrand.map((ele, index) => (
            <div
              id={`vehicle-band-${index}`}
              className={`item${vehicleBrand === ele.value ? ' active' : ''}`}
              key={randomNumber()}
              onClick={() => this.handleEvent(ele.value, 'vehicleBrand')}
            >
              <span>{ele.label}</span>
            </div>
          ));
        case 'parkingGateLocation':
          return commonConstant.parkingGateLocation.map((ele, index) => (
            <div
              id={`parking-gate-location-${index}`}
              className={`item${parkingGateLocation === ele.value ? ' active' : ''}`}
              key={randomNumber()}
              onClick={() => this.handleEvent(ele, 'parkingGateLocation')}
            >
              <span>{ele.label}</span>
            </div>
          ));
        case 'parkingGatePosition':
          return iotDevices.IN.map((ele, index) => (
            <div
              id={`parking-gate-position-${index}`}
              className={`item${parkingGatePosition === ele.buildingIotDevicePosition ? ' active' : ''}`}
              key={randomNumber()}
              onClick={() => this.handleEvent(ele, 'parkingGatePosition')}
            >
              <span>{`Gate - ${ele.buildingIotDevicePosition}`}</span>
            </div>
          ));
        default:
          return null;
      }
    } catch (error) {
      return null;
    }
  }

  handleEvent = (event, key) => {
    const { canEdit, vehicleLicensePlate, vehicleID, vehicleData, vehicleProvince, vehicleType } = this.state;

    if (key === 'vehicleLicensePlate') {
      if (validateVehiclePlate(event.target.value)) {
        if (event.target.value.length >= 3) {
          this.handleClearCarDetail();
          this.setState({ [key]: event.target.value });
          return this.handleSearchVehiclePlate(event.target.value);
        }
        this.handleClearCarDetail();
        return this.setState({ [key]: event.target.value });
      }
    } else if (key === 'vehicleProvince' && ((vehicleID && !vehicleData.vehicleProvince) || (!vehicleID && vehicleLicensePlate))) {
      if (vehicleProvince && vehicleLicensePlate && vehicleType) {
        this.setState({ 'checkAutoFill': true });
        this.handleSearchVehiclePlate(vehicleLicensePlate);
      }
      this.vehicleProvince.current.handleShowItem();
      return this.setState({ [key]: event });
    } else if (key === 'vehicleBrand' && canEdit) {
      if (event && !event?.target?.value) {
        this.vehicleBrand.current.handleShowItem();
        return this.setState({ [key]: event });
      }
      return this.setState({ [key]: event.target.value });
    } else if (key === 'vehicleType') {
      if (vehicleProvince && vehicleLicensePlate && vehicleType) {
        this.setState({ 'checkAutoFill': true });
        this.handleSearchVehiclePlate(vehicleLicensePlate);
      }
      this.vehicleType.current.handleShowItem();
      return this.setState({ [key]: event, 'vehicleBrand': '' });
    } else if (key === 'parkingGateLocation') {
      if (event && !event?.target?.value) {
        this.setState({ [key]: event });
        this.parkingGateLocation.current.handleShowItem();
      }
    } else if (key === 'parkingGatePosition') {
      if (event && !event?.target?.value) {
        this.setState({ [key]: event });
        this.parkingGatePosition.current.handleShowItem();
      }
    } else if (canEdit) {
      return this.setState({ [key]: event.target.value });
    }
  }

  handleSearchVehiclePlate = value => this.props.dispatch(fetchSearchVehicleLicensePlate(value));

  handleCreateParking = () => {
    const { getBuildingByRefNo } = this.props;
    const {
      parkingTimeIn,
      vehicleType,
      vehicleBrand,
      vehicleModel,
      vehicleModelYear,
      vehicleColor,
      vehicleLicensePlate,
      vehicleProvince,
      vehicleID,
      parkingGateLocation,
      parkingGatePosition,
    } = this.state;

    if (!vehicleLicensePlate || !vehicleType || !vehicleProvince || !parkingGateLocation || !parkingGatePosition) { // check required fill
      return null;
    }
    this.setState({ 'loading': true });
    return this.props.dispatch(fetchCreateParking({
      'buildingID': buildingID(getBuildingByRefNo),
      'vehicleID': vehicleID ? vehicleID : null,
      'parkingTimeIn': `${dateYYYYMMDD(parkingTimeIn)} ${getTimeHHMMSS(parkingTimeIn)}`,
      'vehicleType': vehicleType ? vehicleType.value : null,
      'vehicleBrand': vehicleBrand ? vehicleBrand : null,
      'vehicleModel': vehicleModel ? vehicleModel : null,
      'vehicleModelYear': vehicleModelYear ? vehicleModelYear : null,
      'vehicleColor': vehicleColor ? vehicleColor : null,
      vehicleLicensePlate,
      'vehicleProvince': vehicleProvince ? vehicleProvince : null,
      'parkingGateLocation': parkingGateLocation ? parkingGateLocation.value : null,
      'parkingGatePosition': parkingGatePosition ? parkingGatePosition.buildingIotDevicePosition : null,
    }));
  }

  handleItems = () => {
    try {
      const { vehicleLicensePlate } = this.state;
      const { searchVehicleLicensePlate } = this.props;

      if (!searchVehicleLicensePlate || searchVehicleLicensePlate.length === 0) {
        return null;
      }
      const activeItem = searchVehicleLicensePlate.length === 1 && searchVehicleLicensePlate[0].vehicleLicensePlate === vehicleLicensePlate;

      return (
        searchVehicleLicensePlate.map((ele, index) => (
          <div
            id={`input-license-${index}`}
            className={`item${activeItem ? ' active' : ''}`}
            key={randomNumber()}
            onClick={() => this.handleSelectItem(ele)}
          >
            <span>{validateToShowDash(ele.vehicleLicensePlate)}</span>
            <span>{ele.vehicleProvince}</span>
            <IconVehicle className="icon" name={vehicleTypeIconName(vehicleType(ele))}/>
          </div>
        ))
      );
    } catch (error) {
      return null;
    }
  }

  handleCheckEdit = () => {
    try {
      const { vehicleLicensePlate, vehicleProvince, vehicleType } = this.state;
      const { searchVehicleLicensePlate } = this.props;

      if (vehicleProvince && vehicleLicensePlate && vehicleType) {
        this.setState({ 'checkAutoFill': true });
        this.handleSearchVehiclePlate(vehicleLicensePlate);
      }

      if (this.search.current.state.showDropdown) {
        if (vehicleLicensePlate && !vehicleLicensePlate.label) { // new car
          return this.setState({ 'canEdit': true });
        } else if (vehicleLicensePlate && searchVehicleLicensePlate.length === 1 && searchVehicleLicensePlate[0].vehicleLicensePlate === vehicleLicensePlate) { // match car but user don not click auto fill
          return this.handleSelectItem(searchVehicleLicensePlate[0]);
        }
        return this.setState({ 'canEdit': false });
      }
      return null;
    } catch (error) {
      return null;
    }
  }

  handleSelectItem = data => {
    this.setState({
      'vehicleType': this.handleFindVehicleType(data.vehicleType),
      'vehicleID': data.vehicleID,
      'vehicleBrand': data.vehicleBrand,
      'vehicleModel': data.vehicleModel,
      'vehicleModelYear': data.vehicleModelYear,
      'vehicleColor': data.vehicleColor,
      'vehicleLicensePlate': data.vehicleLicensePlate,
      'vehicleProvince': data.vehicleProvince,
      'loading': false,
      'canEdit': false,
      'vehicleData': data,
    });

    if (this.search.current.state.showDropdown) {
      this.search.current.handleShowItem();
    }
  }

  handleClearCarDetail = () => this.setState({
    'vehicleType': null,
    'vehicleID': null,
    'vehicleBrand': '',
    'vehicleModel': '',
    'vehicleModelYear': '',
    'vehicleColor': '',
    'vehicleLicensePlate': '',
    'vehicleProvince': '',
    'canEdit': false,
    'vehicleData': {},
  });

  handleFindVehicleType = vehicleType => {
    try {
      return commonConstant.vehicleType.find(element => element.value === vehicleType);
    } catch (error) {
      return null;
    }
  }

  handleKeyPress = event => {
    const { vehicleLicensePlate } = this.state;

    if (event.key === 'Enter' && vehicleLicensePlate) {
      this.search.current.handleShowDropdown();
      this.handleSearchVehiclePlate(vehicleLicensePlate);

      return this.setState({ 'checkAutoFill': true });
    }
  }

  render() {
    const { getBuildingByRefNo } = this.props;
    const {
      parkingTimeIn,
      vehicleType,
      vehicleBrand,
      vehicleModel,
      vehicleModelYear,
      vehicleColor,
      vehicleLicensePlate,
      vehicleProvince,
      loading,
      vehicleID,
      vehicleData,
      parkingGateLocation,
      parkingGatePosition,
      modalNotAllowParkingZone,
    } = this.state;

    return (
      <div className="CreateParking">
        {loading ? <Loading/> : null}
        <Modal show={modalNotAllowParkingZone}>
          <div className="modal-not-allow-parking-zone-container">
            <div className="modal-not-allow-parking-zone-title">ไม่สามารถเปิดให้เข้าสู่ลานจอดได้</div>
            <div className="modal-not-allow-parking-zone-detail" id="not-allow-parking-zone-error-detail">บริเวณนี้เข้าได้เฉพาะยานพาหนะที่มีสิทธิ์ใช้บริการที่ลานจอดเท่านั้น</div>
            <Button className="btn-primary btn-accept" id="btn-accept" onClick={() => this.setState({
              'modalNotAllowParkingZone' : false,
            })}>รับทราบ</Button>
          </div>
        </Modal>
        <Toast
          text="ป้ายทะเบียนนี้มีอยู่ในระบบ ไม่สามารถสร้างข้อมูลซ้ำได้ ระบบจะทำการกรอกข้อมูลให้อัตโนมัติ"
          id="toast"
          ref={this.toast}
        />
        <div className="box-building">
          <div className="left">
            <div className="title">Building</div>
            <div className="detail" id="building-name">
              {validateToShowDash(buildingName(getBuildingByRefNo))}
            </div>
          </div>
          <div className="right">
            <div className="title">Building ref. no.</div>
            <div className="detail" id="building-ref">
              {validateToShowDash(buildingRefNumber(getBuildingByRefNo))}
            </div>
          </div>
        </div>
        <div className="box-parking-time">
          <div className="title"><span className="icon far fa-clock"/>วัน เวลาเข้าจอด</div>
          <div className="time-in" id="parking-date-time">
            วัน
            <span className="space" id="parking-date">{dateDDMMYYFormat(parkingTimeIn)}</span>
            เวลา
            <span className="space" id="parking-time">{getTimeHHMM(parkingTimeIn)}</span>
          </div>
          <div className="car">
            <div className="left">
              <div className="title">เลขทะเบียนรถ**</div>
              <DropdownSearch
                noIcon
                id="input-license"
                classNameInput="green"
                placeholder="กรอกเลขทะเบียนรถ"
                template="e"
                value={vehicleLicensePlate}
                onChange={event => this.handleEvent(event, 'vehicleLicensePlate')}
                handleClickOutSide={this.handleCheckEdit}
                onKeyPress={this.handleKeyPress}
                items={vehicleLicensePlate && vehicleLicensePlate.length > 2 ? this.handleItems() : null}
                ref={this.search}
              />
            </div>
            <div className="right">
              <div className="title">จังหวัด **</div>
              <Dropdown
                className="province"
                id="vehicle-province"
                template="a"
                placeholder="ระบุจังหวัด"
                value={vehicleProvince ? vehicleProvince.label ? vehicleProvince.label : vehicleProvince : null}
                ref={this.vehicleProvince}
                readOnly={(!vehicleID && !vehicleLicensePlate) || (vehicleID && vehicleData.vehicleProvince) ? true : false}
              >
                {this.handleDropdownItems('province')}
              </Dropdown>
            </div>
          </div>
        </div>
        <div className="box-car-detail">
          <div className="title">
            <span className="icon icon-car"/>
            รายละเอียดตัวรถ (optional)
          </div>
          <hr/>
          <div className="row-detail">
            <div className="left">
              <div className="label">ยี่ห้อรถ</div>
              {
                vehicleType && vehicleType.value === commonConstant.vehicleTypeMotorcycle ?
                  <Input
                    id="vehicle-brand"
                    className="green"
                    placeholder="ระบุยี่ห้อรถ"
                    value={vehicleBrand}
                    onChange={event => this.handleEvent(event, 'vehicleBrand')}
                    readOnly={vehicleID ? true : !vehicleType?.value ? true : false}
                  />
                  : <Dropdown
                    id="vehicle-brand"
                    template="a"
                    placeholder="ระบุยี่ห้อรถ"
                    value={vehicleBrand ? vehicleBrand.label ? vehicleBrand.label : vehicleBrand : null}
                    ref={this.vehicleBrand}
                    readOnly={vehicleID ? true : !vehicleType?.value ? true : false}
                  >
                    {this.handleDropdownItems('brand')}
                  </Dropdown>
              }
            </div>
            <div className="right">
              <div className="label">ประเภทรถ**</div>
              <Dropdown
                id="vehicle-type"
                template="a"
                placeholder="ระบุประเภทรถ"
                value={vehicleType ? vehicleType.label : null}
                ref={this.vehicleType}
                readOnly={(vehicleID || (!vehicleLicensePlate)) ? true : false}
              >
                {this.handleDropdownItems('type')}
              </Dropdown>
            </div>
          </div>
          <div className="row-detail">
            <div className="left">
              <div className="label">รุ่นรถ</div>
              <Input
                id="vehicle-model"
                className="green"
                placeholder="ระบุรุ่นรถ"
                value={vehicleModel}
                onChange={event => this.handleEvent(event, 'vehicleModel')}
                readOnly={(vehicleID || (!vehicleLicensePlate)) ? true : false}
              />
            </div>
            <div className="right">
              <div className="label">สี</div>
              <Input
                id="vehicle-color"
                className="green"
                placeholder="ระบุสีตัวรถ"
                value={vehicleColor}
                onChange={event => this.handleEvent(event, 'vehicleColor')}
                readOnly={(vehicleID || (!vehicleLicensePlate)) ? true : false}
              />
            </div>
          </div>
          <div className="row-detail">
            <div className="left">
              <div className="label">ปี</div>
              <Input
                id="vehicle-year"
                className="green"
                placeholder="ระบุปีรถ"
                value={vehicleModelYear}
                onChange={event => this.handleEvent(event, 'vehicleModelYear')}
                readOnly={(vehicleID || (!vehicleLicensePlate)) ? true : false}
              />
            </div>
          </div>
        </div>
        <div className="box-parking-detail">
          <div className="title">
            {/*TODO: change icon relates to UI*/}
            {/*<span className="icon icon-download"/>*/}
            <span className="location-icon-container"><img className="location-icon" src={commonConstant.locationImage} alt=""/></span>
            รายละเอียดที่จอด**
          </div>
          <hr/>
          <div className="row-detail">
            <div className="left">
              <div className="label" id="parking-gate-location-dropdown-label">Location**</div>
              {/* TODO: loop display parking gate location*/}
              <Dropdown
                id="parking-gate-location-dropdown"
                template="a"
                placeholder="Location"
                value={parkingGateLocation ? parkingGateLocation.label : null}
                ref={this.parkingGateLocation}
              >
                {this.handleDropdownItems('parkingGateLocation')}
              </Dropdown>
            </div>
            <div className="right">
              <div className="label" id="parking-gate-position-dropdown-label">Position**</div>
              <Dropdown
                id="parking-gate-position-dropdown"
                template="a"
                placeholder="Position"
                value={parkingGatePosition ? `Gate - ${parkingGatePosition.buildingIotDevicePosition}` : null}
                ref={this.parkingGatePosition}
              >
                {this.handleDropdownItems('parkingGatePosition')}
              </Dropdown>
            </div>
          </div>
        </div>
        <Button className="btn-save" id="btn-save" onClick={this.handleCreateParking}>บันทึกข้อมูล</Button>
      </div>
    );
  }
}

CreateParking.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'getBuildingByRefNo': PropTypes.shape({}),
  'searchVehicleLicensePlate': PropTypes.array,
  'createParking': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({}),
    'errorMessage': PropTypes.string,
  }),
};

const mapStateToProps = ({ getBuildingByRefNo, searchVehicleLicensePlate, createParking, iotDevices }) => ({
  'getBuildingByRefNo': getBuildingByRefNo.data,
  'searchVehicleLicensePlate': searchVehicleLicensePlate.data,
  createParking,
  'iotDevices': iotDevices.data,
});

export default connect(mapStateToProps)(CreateParking);
